import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ImageUploader, ImageUploaderFigure, ImageCropper } from '@dmi-mch/components';
/**
 * Encapsulation of the Image Cropper.
 * Just to reduce lines every time it's used.
 */

var ImageCropWrap = function ImageCropWrap(_ref) {
  var values = _ref.values,
      setFieldValue = _ref.setFieldValue,
      labelObj = _ref.labelObj,
      twelveCols = _ref.twelveCols,
      extraProps = _ref.extraProps,
      configuration = _ref.configuration,
      name = _ref.name,
      imageValue = _ref.imageValue,
      placeholderMessage = _ref.placeholderMessage,
      figureHeight = _ref.figureHeight,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 400 : _ref$minWidth,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 400 : _ref$minHeight,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? configuration.uploader ? configuration.uploader.maxHeight : null : _ref$maxHeight,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? configuration.uploader ? configuration.uploader.maxWidth : null : _ref$maxWidth,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? 10485760 : _ref$maxSize,
      _ref$cropWidth = _ref.cropWidth,
      cropWidth = _ref$cropWidth === void 0 ? 160 : _ref$cropWidth,
      _ref$cropHeight = _ref.cropHeight,
      cropHeight = _ref$cropHeight === void 0 ? 100 : _ref$cropHeight;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      cropConfirmed = _useState2[0],
      setCropConfirmed = _useState2[1];

  var selectImage = function selectImage(ref, type) {
    if (values && (values.eventImage && type === 'eventImage' || values.coverImageUrl && type === 'coverImageUrl' || values.imageUrl && type === 'imageUrl')) {
      setFieldValue(type, '');
    } else {
      setCropConfirmed(false);
      ref.open();
    }
  };

  var _onCropConfirmed = function onCropConfirmed(image, type) {
    if (image && image.url) {
      setCropConfirmed(true);
      setFieldValue(type, image.url);
    }
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageUploader, {
    accept: ".jpg,.jpeg,.jpe,.png",
    maxSize: maxSize,
    minWidth: minWidth,
    minHeight: minHeight,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    name: name,
    id: name,
    updateProp: imageValue,
    labelObj: labelObj.labelsValidation,
    twelveCols: twelveCols
  }, function (ref, file) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageUploaderFigure, {
      onClick: function onClick() {
        return selectImage(ref, name);
      },
      imageUrl: imageValue,
      placeholderMessage: placeholderMessage,
      figureHeight: figureHeight
    }), (file && file.length && ref) !== null && /*#__PURE__*/React.createElement(ImageCropper, {
      open: !cropConfirmed,
      fileUrl: file[0].preview,
      file: file[0],
      configuration: configuration,
      cloudinary: configuration.cloudinary,
      onCropConfirmed: function onCropConfirmed(img) {
        _onCropConfirmed(img, name);
      },
      tags: extraProps.tags,
      cropProperties: {
        x: 20,
        y: 20,
        width: cropWidth,
        height: cropHeight,
        aspect: cropWidth / cropHeight
      }
    }));
  }));
};

ImageCropWrap.propTypes = {
  configuration: PropTypes.object,
  extraProps: PropTypes.object,
  labelObj: PropTypes.object,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  twelveCols: PropTypes.bool,
  imageValue: PropTypes.string,
  name: PropTypes.string,
  placeholderMessage: PropTypes.string,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  maxSize: PropTypes.number,
  cropWidth: PropTypes.number,
  cropHeight: PropTypes.number,
  figureHeight: PropTypes.number
};
export default ImageCropWrap;